export default [
  {
    text: 'folio',
    value: 'pch_provider_debt_to_pay_number',
  },
  {
    text: 'tipo',
    value: 'pch_provider_debt_to_pay_type',
    align: 'center',
    component: {
      type: 'chip-label',
      props: {
        small: true,
      }
    },
  },
  {
    text: 'pagado',
    value: 'total',
    format: 'currency',
    align: 'right',
  },
  {
    text: 'total',
    value: 'pch_provider_debt_to_pay_total',
    format: 'currency',
    align: 'right',
  },
  {
    text: 'fecha',
    value: 'created_at',
    format: 'date',
    align: 'right',
  },
]